// External
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { tv4 } from 'tv4';

// Internal
import { ConfigService } from 'src/app/common/config/config.service';
import { RequestsService } from '../../global/request-service/requests.service';
import { UtilsCommonService } from 'src/app/common/utils/utils-common.service';
import { ValuesService } from '../../../values/values.service';
import { schemas } from '../../../../common/models/schemas';


@Injectable({
  providedIn: 'root'
})
export class SupportMgmtService {
    searchLang: any;

    constructor(
        private configService: ConfigService,
        private cookiesService: CookieService,
        private http: HttpClient,
        private requestService: RequestsService,
        private utilsService: UtilsCommonService,
        private valuesService: ValuesService
    ) {}

    // **
    //  * This method is used to get an article
    //  * @param {object} Contains mandatory `args.article_id`
    //  * @returns Response from server
    //  */
    getArticle(articleIds): Observable<any> {
        if (!articleIds) {
            return throwError('Invalid params');
        }

        if (articleIds && Array.isArray(articleIds) && !articleIds.length) {
            return throwError('Invalid params');
        }

        let jsons = [];

        if (Array.isArray(articleIds)) {
            for (let i in articleIds) {
                jsons.push(
                    {
                        id: parseInt(i),
                        jsonrpc: this.valuesService.jsonrpc,
                        method: 'get_cs_article_info',
                        params: {
                            connect_source: {
                                user_token: this.cookiesService.get(this.valuesService.cookieToken),
                                device_id: 'web',
                                app_id: this.valuesService.connectAppId
                            },
                            cs_article_id: articleIds[i]
                        }
                    }
                )
            }
        } else {
            jsons.push(
                {
                    id: parseInt((Math.random() * 100).toString(), 10),
                    jsonrpc: this.valuesService.jsonrpc,
                    method: 'get_cs_article_info',
                    params: {
                        connect_source: {
                            user_token: this.cookiesService.get(this.valuesService.cookieToken),
                            device_id: 'web',
                            app_id: this.valuesService.connectAppId
                        },
                        cs_article_id: articleIds,
                    }
                }
            )
        }

        return this.requestService.make(this.configService.config.nimbusServer, this.valuesService.connectSupportService, jsons, 'POST')
        .pipe(
            map((resp) => {
                if (!Array.isArray(resp)) {
                    throw resp;
                }

                let parsedResponses = [];
                for (const response of resp) {
                    if (response.result) {
                        parsedResponses.push(response.result)
                    } else if (response.error.data.code !== 2109) {
                        throw response;
                    }
                }
                return parsedResponses;
            }),
            catchError((error) => {
                const storage = JSON.parse(sessionStorage.getItem('securityNewsCache'));
                if (storage) {
                    return storage;
                } else {
                    throw error;
                }
            })
        );
    }

    /**
     * This method is used to submit ticket to deskpro
     * @param {object} Contains mandatory `args`
     * @returns Response from server
     */
    submitTicket(args: any): Observable<any> {
        if (!tv4.validate(args, schemas.schemaListSubmitTicket)) {
            console.error('Invalid params', tv4.error);
            return throwError('Invalid params');
        }

        let json = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: this.valuesService.jsonrpc,
            method: 'submit_ticket_v2',
            params: {
                connect_source: {
                    user_token: this.cookiesService.get(this.valuesService.cookieToken),
                    device_id: 'web',
                    app_id: this.valuesService.connectAppId
                },
                params: args
            }
        };

        return this.requestService.make(this.configService.config.nimbusServer, this.valuesService.connectSupportService, json, 'POST')
        .pipe(
            map((resp) => {
                return resp;
            }),
            catchError((error) => {
                return throwError(error);
            })
        );
    }


    getSearchResults(page, lang, term): Observable<any> {
        if (!page || !lang || !term) {
            return throwError('Invalid params');
        }
        let json = {
            'id': parseInt((Math.random() * 100).toString(), 10),
            'jsonrpc': this.valuesService.jsonrpc,
            'method': 'search_cs',
            'params': {
                connect_source: {
                    user_token: this.cookiesService.get(this.valuesService.cookieToken),
                    device_id: this.valuesService.connectDeviceId,
                    app_id: this.valuesService.connectAppId
                },
                'page': page,
                'lang': lang,
                'query': term
            }
        };

        return this.requestService.make(this.configService.config.nimbusServer, this.valuesService.connectSupportService, json, 'POST');
    }
}
